/**
 * Ürün Sekmeleri JavaScript
 * Bu dosya ürün sekmeleri için etkileşimli işlevselliği sağlar
 */

(function() {
  document.addEventListener("DOMContentLoaded", function() {
    initTabs();
  });

  function initTabs() {
    // Sekme konteyner sınıfları
    const tabContainers = document.querySelectorAll(".tab-container");
    
    tabContainers.forEach(function(container) {
      const containerID = container.classList[1]; // tab-container-ID formatında
      
      // Masaüstü sekme işlevi
      const desktopContainer = container.querySelector(".desktop-tabs-content");
      if (desktopContainer) {
        const desktopTabs = desktopContainer.querySelectorAll(".tab");
        
        for (let i = 0; i < desktopTabs.length; i++) {
          desktopTabs[i].addEventListener("click", function(e) {
            // Aktif sekme sınıfını kaldır
            for (let j = 0; j < desktopTabs.length; j++) {
              desktopTabs[j].classList.remove("active");
            }
            
            // Tıklanan sekme butonunu aktif yap
            this.classList.add("active");
            
            // Tüm sekme içeriklerini gizle
            const tabContents = desktopContainer.querySelectorAll(".tab-content");
            for (let j = 0; j < tabContents.length; j++) {
              tabContents[j].classList.remove("active");
            }
            
            // İlgili sekme içeriğini göster
            const tabToShow = this.getAttribute("data-tab");
            const contentToShow = desktopContainer.querySelector(".tab-content[data-tab='" + tabToShow + "']");
            if (contentToShow) {
              contentToShow.classList.add("active");
            }
          });
        }
      }
      
      // Mobil akordiyon işlevi
      const mobileContainer = container.querySelector(".tabs-mobile");
      if (mobileContainer) {
        const accordionTabs = mobileContainer.querySelectorAll(".accordion-tab");
        
        // Aktif sekmenin içerik yüksekliğini ayarla
        function setActiveAccordionHeight() {
          const activeContent = mobileContainer.querySelector(".accordion-content.active");
          if (activeContent) {
            // Başlangıçta aktif içeriğin yüksekliğini ayarla
            activeContent.style.maxHeight = activeContent.scrollHeight + "px";
          }
        }
        
        // Sayfa yüklendiğinde aktif sekmenin yüksekliğini ayarla
        setActiveAccordionHeight();
        
        // Her bir akordiyon sekmesine tıklama işlevi ekle
        for (let i = 0; i < accordionTabs.length; i++) {
          accordionTabs[i].addEventListener("click", function(e) {
            const tabId = this.getAttribute("data-tab");
            const content = document.getElementById(tabId);
            
            // Tıklanan sekme zaten aktifse kapat
            if (this.classList.contains("active")) {
              this.classList.remove("active");
              content.classList.remove("active");
              content.style.maxHeight = null;
            } else {
              // Önemli: Diğer sekmeleri otomatik kapatmayı durdurduk
              // Bu, scroll sorununu çözecek
              
              // Doğrudan tıklanan sekmeyi aç
              this.classList.add("active");
              if (content) {
                content.classList.add("active");
                content.style.maxHeight = content.scrollHeight + "px";
              }
            }
            
            // Otomatik kaydırmayı engelle
            e.preventDefault();
          });
        }
        
        // Ekran boyutu değiştiğinde yükseklikleri güncelle
        window.addEventListener("resize", function() {
          const activeContent = mobileContainer.querySelector(".accordion-content.active");
          if (activeContent) {
            activeContent.style.maxHeight = activeContent.scrollHeight + "px";
          }
        });
      }
    });
  }
})();
